export var RegexCharacterType;
(function (RegexCharacterType) {
    RegexCharacterType["Letters"] = "Letters";
    RegexCharacterType["Numbers"] = "Numbers";
    RegexCharacterType["BasicPunctuation"] = "BasicPunctuation";
    RegexCharacterType["BasicSymbols"] = "BasicSymbols";
    RegexCharacterType["Spaces"] = "Spaces";
})(RegexCharacterType || (RegexCharacterType = {}));
const CHARACTER_REGEX = {
    [RegexCharacterType.Letters]: /[a-zA-Z]/,
    [RegexCharacterType.Numbers]: /[0-9]/,
    [RegexCharacterType.Spaces]: /\s/,
    [RegexCharacterType.BasicSymbols]: /[!@#\$%\^&\*\(\)]/,
    [RegexCharacterType.BasicPunctuation]: /[\.\,\;\:\?\!\'\"]/
};
export function getRegex(type) {
    return CHARACTER_REGEX[type];
}
export function matchesAny(input, characterTypeRecord) {
    for (const type of Object.values(RegexCharacterType)) {
        if (characterTypeRecord[type] && input.match(getRegex(type))) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=RegexUtils.js.map